import React from 'react';
import { MyDataGrid, MyTypography } from '../../common/components';
import { isEmpty } from 'lodash';
import ReferralUtils from '../../common/services/ReferralUtils';
import { Stack } from '@mui/material';
import { IconDeviceLandlinePhone } from '@tabler/icons';
import DateTimeUtils from '../../common/services/DateTimeUtils';
import {referralIsOrderColumnItem} from '../../referrals/tables/CommonReferralTable';
import ActiveReferralStatusCell from '../../referrals/tables/components/ActiveReferralStatusCell';
import useCurrentClinicTimeFormat from '../../common/hooks/useCurrentClinicTimeFormat';

export default function ReferralsTable({
  data,
  onFilterChanged,
  onFilterFaxChanged,
  loading,
  onAdd,
  showToolbar = true,
  fromAppointmentAging = false,
  refresh,
}) {
  const currentClinicTimeFormat = useCurrentClinicTimeFormat();

  let columns = [
    {
      field: 'patient',
      headerName: 'Patient Name',
      width: 180,
      valueGetter: params => {
        return params.row.patient?.full_name;
      },
    },
    {
      field: 'provider',
      headerName: 'Provider',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      valueGetter: params => {
        return params.row.provider?.display_name;
      },
    },
    {
      field: 'sender',
      headerName: 'Clinic Sender',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      valueGetter: params => {
        return params.row.referrer?.name;
      },
    },
    {
      field: 'receiver',
      headerName: 'Clinic Receiver',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      renderCell: params => {
        return (
          <Stack direction="row" spacing={1}>
            {(params.row.receiver?.clinic_users_count === 0 && params.row.is_fax) && <IconDeviceLandlinePhone />}
            <MyTypography variant="subtitle1">{params.row.receiver?.name}</MyTypography>
          </Stack>
        );
      },
    },
    {
      field: 'appointment_date',
      headerName: 'Appointment Date',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      valueGetter: params => {
        return DateTimeUtils.formatDisplayDateTime(
          params.row.appointment_date,
          currentClinicTimeFormat,
          true,
        );
      },
      sortComparator: DateTimeUtils.dateSortComparator,
    },
    {
      field: 'status',
      headerName: 'Status',
      sortable: true,
      editable: false,
      filterable: true,
      width: 130,
      valueGetter: params => {
        return ReferralUtils.getStatus(params.row.status, params.row.reason);
      },
      renderCell: (params) => (
        <ActiveReferralStatusCell data={params.row.referral} refresh={refresh} />
      ),
    },
    {
      field: 'sent_at',
      headerName: 'Sent At',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      valueGetter: params => {
        return DateTimeUtils.formatDisplayDateTime(
          params.row.sent_at,
          currentClinicTimeFormat,
          true,
        );
      },
      sortComparator: DateTimeUtils.dateSortComparator,
    },
    referralIsOrderColumnItem,
    {
      field: 'updated_by',
      headerName: 'Last Updated By',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      valueGetter: params => {
        return !isEmpty(params.row.updated_by) ? params.row.updated_by.fullname : '';
      },
    },
    {
      field: 'updated_at',
      headerName: 'Last Updated At',
      sortable: true,
      editable: false,
      filterable: true,
      width: 250,
      valueGetter: params => {
        return DateTimeUtils.formatDisplayDateTime(
          params.row.updated_at,
          currentClinicTimeFormat,
          true,
        );
      },
      sortComparator: DateTimeUtils.dateSortComparator,
    },
    {
      field: 'aging',
      headerName: 'Processing',
      sortable: true,
      editable: false,
      filterable: true,
      width: 180,
      valueGetter: params => {
        return ((params.row.updated_at - params.row.sent_at) / (1000 * 60 * 60 * 24)).toFixed(1);
      },
    },
    {
      field: 'aging_2',
      headerName: 'Aging',
      sortable: true,
      editable: false,
      filterable: true,
      width: 180,
      valueGetter: params => {
        return (((new Date()) - params.row.updated_at) / (1000 * 60 * 60 * 24)).toFixed(1);
      },
    },
  ];

  if(fromAppointmentAging) {
    columns = columns.filter(
      column => column.field !== 'aging' && column.field !== 'aging_2' && column.field !== 'status'
    );
  } else {
    columns = columns.filter(
      column => column.field !== 'appointment_date'
    );
  }

  console.log(data)
  return (
    <MyDataGrid
      onAdd={onAdd}
      loading={loading}
      data={data}
      columns={columns}
      showToolbar={showToolbar}
      getRowId={row => {
        return row.id;
      }}
      minTableHeight={'calc(100vh - 282px)'}
      onFilterChanged={onFilterChanged}
      onFilterFaxChanged={onFilterFaxChanged}
    />
  );
}
